// Read a claim off a Kinde ACCESS-token JWT without verifying its signature -
// we only inspect a claim to decide whether to force a re-auth, never to make a
// trust decision (the BE validates the signature).
//
// Background: operator attribution (principle 27) reads `auth.email` off the
// access token. The InRange-Agents Kinde application now emits `email` on the
// access token - an OIDC `email` scope only populates the ID token, so the
// access token needed the app-level claim enabled. A token issued *before* that
// change lacks `email`; `UserProvider` forces a one-time re-auth to pick up a
// fresh token instead of waiting up to 24h for the silent refresh.
//
// Returns true ONLY when the payload parses cleanly AND `email` is
// absent/blank - i.e. we are confident this is a stale, pre-change token. Any
// parse failure fails OPEN (returns false) so a decode edge case can never sign
// everyone out.
export const accessTokenIsMissingEmail = (jwt: string | undefined | null): boolean => {
  if (!jwt) return false;
  const segment = jwt.split(".")[1];
  if (!segment) return false;
  try {
    const base64 = segment.replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64)) as { email?: unknown };
    return typeof payload.email !== "string" || payload.email.length === 0;
  } catch {
    return false;
  }
};
